import { render } from "./CourseDescriptionCard.vue?vue&type=template&id=6bad3b26&scoped=true"
import script from "./CourseDescriptionCard.vue?vue&type=script&lang=js"
export * from "./CourseDescriptionCard.vue?vue&type=script&lang=js"

import "./CourseDescriptionCard.vue?vue&type=style&index=0&id=6bad3b26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bad3b26"]])

export default __exports__